import React from 'react';
import toolTipIcon from './imgs/toolTipIcon.svg';


const ToolTipIcon = ({ toolTipMessage, style, isLeft }) => {
	const src = "https://uploads-ssl.webflow.com/6191b5ffff40d96697340a9c/61fba78e4f262440d8356fa2_toolTipIcon.c4ea9e3705ab2707a5e5de63d916c7e3.svg";
	return (
		<div className="tooltip">
			<span className={`${isLeft ? 'tooltiptextLeft' : 'tooltiptext'}`}>{toolTipMessage}</span>
			<img src={src} alt="toolTip" style={{ width: '20px', height: '20px', paddingLeft: '5px', ...style }} />
		</div>
	)
}

export default ToolTipIcon;